// extracted by mini-css-extract-plugin
export default {"aside":"Aside-module__aside--k_uNm","scale":"Aside-module__scale--HKOGw","visible":"Aside-module__visible--cYUDd"};